// Proper Refactor: This file now re-exports the centralized coreApi instance.
// This maintains backward compatibility for the rest of the application
// while ensuring all core API calls benefit from the new interceptor logic.

import { coreApi } from './apiInstances';

export default coreApi;
